import { render } from "./index.vue?vue&type=template&id=1f1cac61&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "@/assets/custom-outside.css?vue&type=style&index=0&id=1f1cac61&scoped=true&lang=css"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1cac61"]])

export default __exports__